/**
 * Regional Configuration
 * 
 * Centralized source of truth for supported countries, languages, and currencies.
 * Used for UI dropdowns, geo-localization fallbacks, and storage initialization.
 */

export const SUPPORTED_COUNTRIES = [
    { code: 'AU', name: 'Australia' },
    { code: 'US', name: 'United States' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'CA', name: 'Canada' },
    { code: 'JP', name: 'Japan' },
    { code: 'SG', name: 'Singapore' },
    { code: 'CO', name: 'Colombia' },
    { code: 'MX', name: 'Mexico' },
    { code: 'BR', name: 'Brazil' },
    { code: 'AR', name: 'Argentina' },
    { code: 'CL', name: 'Chile' }
]

export const SUPPORTED_LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'fr', name: 'Français' },
    { code: 'de', name: 'Deutsch' },
    { code: 'it', name: 'Italiano' },
    { code: 'ja', name: '日本語' },
    { code: 'zh', name: '中文' },
    { code: 'ko', name: '한국어' }
]

export const SUPPORTED_CURRENCIES = [
    { code: 'AUD', name: 'Australian Dollar', symbol: '$' },
    { code: 'USD', name: 'US Dollar', symbol: '$' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'GBP', name: 'British Pound', symbol: '£' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
    { code: 'COP', name: 'Colombian Peso', symbol: '$' },
    { code: 'MXN', name: 'Mexican Peso', symbol: '$' },
    { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
    { code: 'CLP', name: 'Chilean Peso', symbol: '$' },
    { code: 'ARS', name: 'Argentine Peso', symbol: '$' }
]

/**
 * Fallback mapping for geo-detection
 */
export const COUNTRY_CURRENCY_MAP = SUPPORTED_COUNTRIES.reduce((map, country) => {
    const currencyMatch = SUPPORTED_CURRENCIES.find(c => {
        if (country.code === 'AU') return c.code === 'AUD'
        if (country.code === 'US') return c.code === 'USD'
        if (['FR', 'DE', 'ES', 'IT'].includes(country.code)) return c.code === 'EUR'
        if (country.code === 'GB') return c.code === 'GBP'
        // Simplified match for others where code often matches currency start
        return c.code.startsWith(country.code)
    })
    if (currencyMatch) map[country.code] = currencyMatch.code
    return map
}, {})

/**
 * Fallback mapping for Spanish-speaking countries
 */
export const COUNTRY_LANGUAGE_MAP = {
    CO: 'es', MX: 'es', ES: 'es', AR: 'es', CL: 'es', PE: 'es',
    FR: 'fr', DE: 'de', JP: 'ja', CN: 'zh', KR: 'ko'
}
